import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { UserContext } from "../../context/UserContext";
import AccessControlMockup from "./AccessControlMockup";
import InventoryMockup from "./InventoryMockup";
import ProductsMockup from "./ProductsMockup";
import MemberManagementMockup from "./MemberManagementMockup";
import AIChatMockup from "./AIChatMockup";
import AccountingMockup from "./AccountingMockup";
import DashboardMockup from "./DashboardMockup";
import "./Landing.css";

const featuresData = [
  {
    id: "entradas",
    title: "Entradas y Aforo",
    description: "Controla el aforo en tiempo real. Busca socios por nombre o número y regístrales la entrada o salida con un clic. Todo el control en la puerta de tu club.",
    component: <AccessControlMockup />,
    imageSrc: "/assets/images/entradas.png",
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
  },
  {
    id: "dispensario",
    title: "Dispensario y Pesaje",
    description: "Pesaje exacto, catálogo visual y control milimétrico de inventario. Gestiona entradas, peso y dispensación por gramo. Flujo específico, rápido y sin errores.",
    component: <InventoryMockup />,
    imageSrc: "/assets/images/dispensario.png",
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/><circle cx="12" cy="12" r="3"/></svg>
  },
  {
    id: "productos",
    title: "Productos Extras",
    description: "Gestiona todo tu catálogo de bebidas, snacks o parafernalia. Organiza por categorías, controla el stock y ajusta precios de forma sencilla.",
    component: <ProductsMockup />,
    imageSrc: "/assets/images/productos.png",
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
  },
  {
    id: "socios",
    title: "Gestión de Socios",
    description: "Ficha de cada socio, consumo histórico, recargas de saldo, cuotas y caducidad. Control total de la membresía para cumplir la normativa sin complicaciones.",
    component: <MemberManagementMockup />,
    imageSrc: "/assets/images/socios.png",
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/></svg>
  },
  {
    id: "ia",
    title: "Asistente IA",
    description: "Pregúntale a tu sistema sobre ventas, previsión de demanda o alertas de stock. Tu empleado digital siempre disponible para analizar los datos de tu club.",
    component: <AIChatMockup />,
    imageSrc: "/assets/images/IA.png",
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2a2 2 0 0 1 2 2c0 .74-.4 1.39-1 1.73V7h1a7 7 0 0 1 7 7h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1H2a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h1a7 7 0 0 1 7-7h1V5.73c-.6-.34-1-.99-1-1.73a2 2 0 0 1 2-2z"/></svg>
  },
  {
    id: "cajas",
    title: "Cajas y Contabilidad",
    description: "Transacciones, historial de ventas y panel de control para tomar decisiones. Cierra caja sin descuadres y mantén la tesorería bajo control.",
    component: <AccountingMockup />,
    imageSrc: "/assets/images/cajas-preview.png",
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
  }
];

const PRICING = {
  annualDiscountPercent: 15,
  plans: [
    {
      id: "prueba",
      name: "Prueba gratis",
      priceLabel: "0 €",
      period: "30 días",
      note: "Sin pago inicial",
      cta: "Empezar gratis",
      features: ["Software completo", "Tu tienda creada y lista", "Sin tarjeta · sin compromiso"],
    },
    {
      id: "club",
      name: "Club",
      priceLabel: "99 €",
      period: "/mes",
      cta: "Empezar",
      features: ["Socios", "Dispensario y pesaje", "Cajas y contabilidad", "Entradas y aforo", "Stock e informes"],
    },
    {
      id: "pro",
      name: "Club Pro",
      priceLabel: "199 €",
      period: "/mes",
      cta: "Empezar",
      features: ["Todo lo del plan Club", "IA avanzada", "Multi-local", "Soporte prioritario"],
    },
  ],
};

const Landing = () => {
  const [activeFeature, setActiveFeature] = useState(0);
  const [openFaq, setOpenFaq] = useState(null);
  const [token] = React.useContext(UserContext);
  const navigate = useNavigate();

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  React.useEffect(() => {
    if (token) { navigate("/dashboard"); }
  }, [token, navigate]);

  return (
    <div className="landing-page">
      <div className="page">
        {/* Hero */}
        <header className="hero">
          <nav className="nav">
            <div className="nav-brand">
              <svg className="logo" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M16 3C9.373 3 4 8.373 4 15c0 5.018 3.08 9.317 7.45 11.116C12.346 27.316 14.063 28 16 28c1.937 0 3.654-.684 4.55-1.884C24.92 24.317 28 20.018 28 15c0-6.627-5.373-12-12-12z" stroke="currentColor" strokeWidth="2" fill="none"/>
                <path d="M16 8a7 7 0 0 0-7 7c0 2.761 1.615 5.14 3.95 6.25.7.332 1.93.75 3.05.75s2.35-.418 3.05-.75A7.002 7.002 0 0 0 23 15a7 7 0 0 0-7-7z" stroke="currentColor" strokeWidth="1.5" fill="none"/>
                <circle cx="16" cy="15" r="2.5" fill="currentColor"/>
              </svg>
              <span className="brand-name">clubsagent.ai</span>
            </div>
            <div className="nav-links">
              <a href="#features">Funciones</a>
              <a href="#how">Cómo funciona</a>
              <a href="#faq">FAQ</a>
              <a href="#contact">Contacto</a>
            </div>
            <div className="nav-actions">
              <Link to="/login" className="btn btn-ghost">Iniciar sesión</Link>
              <Link to="/login" className="btn btn-primary">Acceder a la app</Link>
            </div>
          </nav>
          <div className="container hero-container">
            <div className="hero-content-left">
              <span className="hero-badge">IA y gestión para clubes sociales</span>
              <h1 className="hero-title">Tu empleado digital <br/>y sistema de gestión 360º.</h1>
              <p className="hero-subtitle">
                Controla tu club desde una sola plataforma: socios, dispensación,
                caja e informes. Incluye un Asistente IA que analiza tus datos en tiempo real.
              </p>
              <div className="hero-cta">
                <Link to="/login" className="btn btn-primary btn-lg">Acceder a clubsagent.ai</Link>
                <a href="#features" className="btn btn-outline btn-lg">Ver funciones</a>
              </div>
              <div className="hero-note">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
                <span>Seguro y pensado para el día a día</span>
              </div>
            </div>
            <div className="hero-image-right">
              <DashboardMockup />
            </div>
          </div>
        </header>



        {/* Features */}
        <section id="features" className="section features">
          <div className="container">
            <h2 className="section-title">Lo que necesitas para tu club</h2>
            <p className="section-desc">Socios, dispensario, ventas y asistente IA en una sola plataforma.</p>
            <div className="features-tabs-container">
              <div className="features-sidebar">
                {featuresData.map((feature, index) => (
                  <button 
                    key={feature.id} 
                    className={`feature-tab-btn ${activeFeature === index ? 'active' : ''}`}
                    onClick={() => setActiveFeature(index)}
                  >
                    <div className="feature-tab-icon">{feature.icon}</div>
                    <span>{feature.title}</span>
                  </button>
                ))}
              </div>
              <div className="features-content">
                <div className="features-content-inner">
                  <h3>{featuresData[activeFeature].title}</h3>
                  <p>{featuresData[activeFeature].description}</p>
                  <div className="feature-image-wrapper">
                    {featuresData[activeFeature].component ? (
                      <div key={activeFeature} className="feature-mockup fade-in">
                        {featuresData[activeFeature].component}
                      </div>
                    ) : (
                      <img
                        src={featuresData[activeFeature].imageSrc}
                        alt={featuresData[activeFeature].title}
                        key={activeFeature}
                        className="feature-image fade-in"
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Pricing */}
        <section id="precios" className="section pricing">
          <div className="container">
            <div className="pricing-header">
              <h2 className="section-title">Precios</h2>
              <p className="section-desc">
                Empieza con <strong>30 días gratis</strong>, sin pago inicial. Pago anual:{" "}
                <strong>−{PRICING.annualDiscountPercent}%</strong>.
              </p>
            </div>

            <div className="pricing-grid">
              {PRICING.plans.map((plan) => {
                const highlight = plan.id === "club";
                return (
                  <div key={plan.id} className={`pricing-card ${highlight ? "is-highlight" : ""}`}>
                    {highlight && <div className="pricing-badge">Más popular</div>}
                    {plan.note && <div className="pricing-badge">{plan.note}</div>}
                    <div className="pricing-name">{plan.name}</div>
                    <div className="pricing-price-row">
                      <div className="pricing-price">{plan.priceLabel}<span>{plan.period}</span></div>
                    </div>
                    <ul className="pricing-features">
                      {plan.features.map((f) => (
                        <li key={f}>{f}</li>
                      ))}
                    </ul>
                    <div className="pricing-cta">
                      <Link to="/login" className={`btn ${highlight ? "btn-primary" : "btn-outline"} btn-lg`}>
                        {plan.cta}
                      </Link>
                    </div>
                  </div>
                );
              })}
            </div>

            <p className="pricing-footnote">
              ¿Vienes de otro software? Migramos todos tus datos (socios, saldos, fotos y DNIs) por ti:{" "}
              <strong>migración completa 200 €</strong>, fraccionable a 40 €/mes × 5, solo cuando decides quedarte.
            </p>
          </div>
        </section>

        {/* How it works */}
        <section id="how" className="section journey">
          <div className="container">
            <div className="journey-card">
              <h2 className="section-title">Tu club bajo control en 3 pasos</h2>
              <p className="section-desc">Diseñado para ser implementado en menos de 24 horas, sin fricciones técnicas.</p>
              <div className="journey-grid">
                <div className="journey-step">
                  <span className="step-num">01</span>
                  <h3>Configuración Asistida por IA</h3>
                  <p>Sube un Excel o foto de tu catálogo y nuestra Inteligencia Artificial extraerá y rellenará todos tus datos automáticamente.</p>
                </div>
                <div className="journey-step">
                  <span className="step-num">02</span>
                  <h3>Operación y Dispensación</h3>
                  <p>Tu equipo gestiona entradas y dispensa con pesaje al gramo. Adiós a las mermas desconocidas.</p>
                </div>
                <div className="journey-step">
                  <span className="step-num">03</span>
                  <h3>Optimización con IA</h3>
                  <p>Nuestro asistente inteligente analiza qué productos caducan y qué socios necesitan renovar la cuota.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section id="faq" className="section faq-section">
          <div className="container">
            <div className="faq-card">
              <div className="faq-header">
                <h2 className="section-title">Preguntas frecuentes</h2>
                <p className="section-desc">Resolvemos las dudas más comunes de los clubes sociales.</p>
              </div>
              <div className="faq-list">
                <div className={`faq-item ${openFaq === 0 ? 'is-open' : ''}`}>
                  <button type="button" className="faq-question" onClick={() => toggleFaq(0)} aria-expanded={openFaq === 0}>
                    <span>¿El TPV es exacto para pesar y dispensar al gramo?</span>
                    <span className="faq-icon">+</span>
                  </button>
                  <div className="faq-answer">
                    <p>Sí, nuestro dispensario virtual está diseñado específicamente para el control exhaustivo de mermas, garantizando la trazabilidad desde la llegada del lote hasta la dispensación al socio.</p>
                  </div>
                </div>
                <div className={`faq-item ${openFaq === 1 ? 'is-open' : ''}`}>
                  <button type="button" className="faq-question" onClick={() => toggleFaq(1)} aria-expanded={openFaq === 1}>
                    <span>¿Dónde y cómo se guardan los datos de mis socios?</span>
                    <span className="faq-icon">+</span>
                  </button>
                  <div className="faq-answer">
                    <p>Todos los perfiles y el histórico se almacenan en servidores europeos encriptados, cumpliendo de forma estricta con la normativa RGPD.</p>
                  </div>
                </div>
                <div className={`faq-item ${openFaq === 2 ? 'is-open' : ''}`}>
                  <button type="button" className="faq-question" onClick={() => toggleFaq(2)} aria-expanded={openFaq === 2}>
                    <span>¿Es difícil migrar toda la base de datos de nuestro sistema antiguo?</span>
                    <span className="faq-icon">+</span>
                  </button>
                  <div className="faq-answer">
                    <p>En absoluto. Nos encargamos de la migración de tus datos (socios, inventario, saldos, fotos y DNIs) como servicio de onboarding asistido: lo hacemos por ti para que la transición dure horas, no semanas.</p>
                  </div>
                </div>
                <div className={`faq-item ${openFaq === 3 ? 'is-open' : ''}`}>
                  <button type="button" className="faq-question" onClick={() => toggleFaq(3)} aria-expanded={openFaq === 3}>
                    <span>¿Necesitamos comprar hardware especial como tablets o escáneres?</span>
                    <span className="faq-icon">+</span>
                  </button>
                  <div className="faq-answer">
                    <p>No, clubsagent.ai funciona desde el navegador web en cualquier dispositivo moderno (PC, Mac, iOS o Android). Si ya tenéis lectores de QR o básculas digitales, se pueden integrar de forma sencilla.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Contact */}
        <section id="contact" className="section contact-section">
          <div className="container">
            <div className="contact-card contact-minimal">
              <h2 className="section-title">Sube al siguiente nivel de gestión</h2>
              <p className="section-desc">Escríbenos directamente para agendar una demostración privada del software en funcionamiento.</p>
              
              <div className="contact-cta-wrapper">
                <a href="mailto:admin@clubsagent.ai" className="contact-email-large">
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                  admin@clubsagent.ai
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="footer">
          <div className="container">
            <div className="footer-inner">
              <div className="footer-brand">
                <div className="nav-brand">
                  <svg className="logo" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M16 3C9.373 3 4 8.373 4 15c0 5.018 3.08 9.317 7.45 11.116C12.346 27.316 14.063 28 16 28c1.937 0 3.654-.684 4.55-1.884C24.92 24.317 28 20.018 28 15c0-6.627-5.373-12-12-12z" stroke="currentColor" strokeWidth="2" fill="none"/>
                    <path d="M16 8a7 7 0 0 0-7 7c0 2.761 1.615 5.14 3.95 6.25.7.332 1.93.75 3.05.75s2.35-.418 3.05-.75A7.002 7.002 0 0 0 23 15a7 7 0 0 0-7-7z" stroke="currentColor" strokeWidth="1.5" fill="none"/>
                    <circle cx="16" cy="15" r="2.5" fill="currentColor"/>
                  </svg>
                  <span className="brand-name">clubsagent.ai</span>
                </div>
                <p>Gestión de clubes sociales. Socios, dispensación, ventas y asistente IA en una sola plataforma.</p>
                <p style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "13px", color: "var(--muted)" }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg>
                  Cumplimos el RGPD · Datos alojados en la UE
                </p>
              </div>
              <div className="footer-links">
                <div>
                  <h4>Producto</h4>
                  <ul>
                    <li><a href="#features">Funciones</a></li>
                    <li><a href="#how">Cómo funciona</a></li>
                    <li><Link to="/login">Acceder</Link></li>
                  </ul>
                </div>
                <div>
                  <h4>Soporte</h4>
                  <ul>
                    <li><a href="#faq">FAQ</a></li>
                    <li><a href="mailto:soporte@clubsagent.ai">Contacto</a></li>
                  </ul>
                </div>
              </div>
              <div className="footer-newsletter">
                <h4>Recibe novedades</h4>
                <form className="newsletter-form" onSubmit={(e) => e.preventDefault()}>
                  <input type="email" placeholder="Tu email" required />
                  <button type="submit" className="btn btn-primary">Suscribirse</button>
                </form>
              </div>
            </div>
            <div className="footer-bottom" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", borderTop: "1px solid var(--card-border)", paddingTop: "24px", marginTop: "40px" }}>
              <p style={{ margin: 0 }}>© 2026 clubsagent.ai. Todos los derechos reservados.</p>
              <div className="legal-links" style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
                <Link to="/aviso-legal" style={{ color: "var(--muted)", textDecoration: "none", fontSize: "14px" }}>Aviso Legal</Link>
                <Link to="/privacidad" style={{ color: "var(--muted)", textDecoration: "none", fontSize: "14px" }}>Privacidad</Link>
                <Link to="/cookies" style={{ color: "var(--muted)", textDecoration: "none", fontSize: "14px" }}>Cookies</Link>
                <Link to="/terminos" style={{ color: "var(--muted)", textDecoration: "none", fontSize: "14px" }}>Términos</Link>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default Landing;
